import _ from 'lodash'
import Vue from 'vue'

require('./mixins')

Vue.filter('round', (value, precision = 0) => {
    return _.round(value, precision)
})

Vue.filter('money', (value, decimals = 2) => {
    return _.money(value, decimals)
})

Vue.filter('limit', (value, length) => {
    return _.truncate(value, { length })
})

Vue.filter('join', (array, glue) => {
    return _.join(array, glue)
})

Vue.filter('comma-delimited', (array, { callback = null, total = array.length, empty = 'n/a' }) => {
    if (array.length === 0) {
        return empty
    }

    return _.chain(array)
        .thru(value => {
            if (_.isFunction(callback)) {
                return _.map(value, callback)
            }

            return value
        })
        .thru(value => {
            const last = value.length > 1
                ? value.pop()
                : null

            value = value.join(', ')

            if (total > array.length) {
                value += (last ? ', ' + last : '') + '...'
            } else {
                value += last ? ' & ' + last : ''
            }

            return value
        })
        .value()
})

Vue.filter('ordinal', _.ordinal)
